import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Circle, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import data from './data.json';

const areaCoordinates = {
  "Amager Vest": [55.650, 12.598],
  "Amager Øst": [55.661, 12.622],
  "Bispebjerg": [55.711, 12.5339],
  "Brønshøj-Husum": [55.702, 12.492],
  "Indre By": [55.675, 12.565],
  "Nørrebro": [55.696, 12.545],
  "Valby": [55.659, 12.513],
  "Vanløse": [55.685, 12.490],
  "Vesterbro-Kongens Enghave": [55.663, 12.548],
  "Østerbro": [55.700, 12.580]
};
const MapComponent = () => {
  const [selectedYear, setSelectedYear] = useState("2022");
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    if (autoPlay) {
      const years = ["2022", "2023", "2024"];
      const interval = setInterval(() => {
        setSelectedYear(prev => {
          const currentIndex = years.indexOf(prev);
          return years[(currentIndex + 1) % years.length];
        });
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [autoPlay]);

  // Aggregate data to include both total and breakdown per parking type
  const aggregateData = (year) => {
    const aggregated = {};
    Object.entries(data.data).forEach(([parkingType, typeData]) => {
      Object.entries(typeData).forEach(([area, years]) => {
        if (years[year] !== undefined) {
          if (!aggregated[area]) {
            aggregated[area] = { total: 0, breakdown: {} };
          }
          aggregated[area].total += years[year];
          aggregated[area].breakdown[parkingType] = (aggregated[area].breakdown[parkingType] || 0) + years[year];
        }
      });
    });
    return aggregated;
  };

  const aggregated = aggregateData(selectedYear);
  const scaleFactor = 1.7; // adjust as needed

  return (
    <div style={{ position: "relative", height: "100vh", width: "100%" }}>
      <MapContainer center={[55.6761, 12.5683]} zoom={13} style={{ height: "100%", width: "100%" }}>
        <TileLayer url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png" 
        attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM' />
        {Object.entries(aggregated).map(([area, { total, breakdown }]) => {
          const radius = total * scaleFactor;
          const icon = L.divIcon({
            html: `<div style="text-align:center; color:white; font-size:15px; font-weight:bold;">${total}</div>`,
            className: 'custom-div-icon',
            iconSize: [30, 30],
            iconAnchor: [15, 15]
          });
          return (
            <React.Fragment key={area}>
              <Circle center={areaCoordinates[area]} radius={radius} fillColor="blue" color="blue" fillOpacity={0.5} />
              <Marker position={areaCoordinates[area]} icon={icon}>
                <Popup>
                  <div>
                    <strong>{area}</strong>
                    <br />
                    Total: {total}
                    <br />
                    {Object.entries(breakdown).map(([type, count]) => (
                      <div key={type}>{type}: {count}</div>
                    ))}
                  </div>
                </Popup>
              </Marker>
            </React.Fragment>
          );
        })}
      </MapContainer>
      <div style={{
        position: "absolute", top: "10px", left: "50%", transform: "translateX(-50%)",
        backgroundColor: "rgba(255,255,255,0.7)", padding: "5px", borderRadius: "5px",
        zIndex: 1000, textAlign: "center"
      }}>
        <div style={{ marginBottom: "5px" }}>Årstal: {selectedYear}</div>
        <input type="range" min="2022" max="2024" step="1" value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          disabled={autoPlay} />
        <div style={{ marginTop: "5px" }}>
          <label>
            <input type="checkbox" checked={autoPlay} onChange={(e) => setAutoPlay(e.target.checked)} />
            Automatisk Årsskifte
          </label>
        </div>
      </div>
    </div>
  );
};

export default MapComponent;
